import DashboardPage from '@/pages/dashboard/Dashboard.vue'

export default [
  {
    path: '/dashboard/',
    component: DashboardPage
  },
  {
    path: '/directPayments/dashboard/',
    component: DashboardPage
  },
  {
    path: '/directDebit/dashboard/',
    component: DashboardPage
  }
]
